import VideoPlayer from "components/VideoPlayer";
import React from "react";

function ProcessSection({ theme, headingIcon, heading, description, video }) {
  return (
    <section
      className="flex flex-col items-center gap-6 md:gap-9 px-5 py-9 md:py-[3.75rem] relative"
      style={{ background: theme.process.backgroundColor }}
    >
      <div className="flex flex-col items-center gap-1 md:gap-6">
        <div className="relative w-fit">
            <h1 className="text-center font-bold text-2xl leading-normal md:text-[2.5rem]">{heading}</h1>
            <img src={headingIcon} className="absolute hidden md:block top-0 left-8 -translate-x-full -translate-y-full w-[200px]" />
        </div>
        <p className="text-center text-base md:text-2xl">{description}</p>
      </div>
      <div className="relative w-full max-w-sm md:max-w-[45rem]">
        <div className="w-full aspect-w-16 aspect-h-9 rounded-lg overflow-hidden">
          <VideoPlayer
            videoPlayerClassName="!absolute !h-full !w-full !mt-0 hide-vjs-spinner"
            sources={[video]}
            showOverlay={false}
          />
        </div>
      </div>
    </section>
  );
}

export default ProcessSection;
